import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import styles from '../../styles/ClosingMessage.module.css';

export default function ClosingMessage() {
  const [ref, isVisible] = useScrollAnimation({ once: true });

  return (
    <section id="closing" ref={ref} className={`${styles.closing} ${isVisible ? styles.visible : ''}`}>
      <div className={styles.content}>
        <div className={styles.statements}>
          <p className={styles.statement}>쿠팡이 쇼핑을 바꿨습니다.</p>
          <p className={styles.statement}>배달의민족이 음식 주문을 바꿨습니다.</p>
          <p className={styles.statement}>야놀자가 숙박 예약을 바꿨습니다.</p>
        </div>

        <div className={styles.mainMessage}>
          <p className={styles.highlight}>이제 올림이 스포츠 예약을 바꿉니다.</p>
        </div>

        <h2 className={styles.title}>
          스포츠 예약, 이제 올림으로 쉽게
        </h2>

        <div className={styles.cta}>
          <a href="https://admin.olym.kr/onboarding" target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-lg">
            무료로 시작하기
          </a>
        </div>
      </div>
    </section>
  );
}
